var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.83,9.71a2.89,2.89,0,0,0-2-.84H9.21a2.87,2.87,0,0,0-2,.84,2.84,2.84,0,0,0-.85,2V23.26a2.89,2.89,0,0,0,2.88,2.87H25.79a2.87,2.87,0,0,0,2.88-2.85V11.75A2.89,2.89,0,0,0,27.83,9.71ZM8.28,10.83a1.31,1.31,0,0,1,.93-.39H25.79a1.44,1.44,0,0,1,.5.1,1.42,1.42,0,0,1,.43.29,1.35,1.35,0,0,1,.38.93V14.4H7.9V11.75A1.3,1.3,0,0,1,8.28,10.83ZM26.71,24.21a1.3,1.3,0,0,1-.92.38H9.21A1.3,1.3,0,0,1,7.9,23.28V16H27.1v7.31A1.27,1.27,0,0,1,26.71,24.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.35,19.49h-3a.78.78,0,0,0-.55.23.75.75,0,0,0-.23.55.79.79,0,0,0,.78.79h3a.79.79,0,0,0,.56-.23.83.83,0,0,0,.23-.56.79.79,0,0,0-.79-.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.21a31b0d9e4360e934ed6ebf4bfbee5e.svg";
export { ForwardRef as ReactComponent };